import NavBar from "../components/NavBar/NavBar"
export default function Header() {
  return (
        <section className="header-nav">
            <div id="NavBar" className="Navbar">
                <NavBar />
            </div>
      </section>
  )
}